// extracted by mini-css-extract-plugin
export default {"errorContainer":"bihTJsuzs0CPRZHPMGYQ","list":"OnqtU9FRHoQDXT2LSSig","link":"ohBC0tDzoTLP3HAVwstu"};